import { createRouter, createWebHistory } from 'vue-router';
/**
 * Search components
 */
import SearchIndexComponent from '@/components/search/search-index.vue';

const searchRouter = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:search-location',
      name: 'SearchIndex',
      // component: () => import(/* webpackChunkName: "group-search" */ '@/components/search/search-index.vue'),
      component: SearchIndexComponent,
    },
    { path: '/search-jobs', component: SearchIndexComponent, children: [{ path: ':params+', name: 'search-jobs', component: SearchIndexComponent }] },
    { path: '/search-reviews', component: SearchIndexComponent, children: [{ path: ':params+', name: 'search-reviews', component: SearchIndexComponent }] },
    { path: '/search-companies', component: SearchIndexComponent, children: [{ path: ':params+', name: 'search-companies', component: SearchIndexComponent }] },
  ],
});
export default searchRouter;